export default "/_next/static/chunks/fonts/TheinhardtMedium-a70b7a21ded35527e56dbe89e4b85f75.woff2";